import { get, post, deleteFun, upload, put } from '@/utils/request.js';
// 用户管理

/**
 * 用户登录
 * userName
 * password
 */
export function login(params) {
    return get('/mpp/user/login', params);
}
/**
 * 用户短信登录
 * userName
 * password
 */
export function smsLogin(params) {
    return get('/mpp/auth/phone/codeLogin', params);
}
/**
 * 获取短信验证码
 * userName
 * password
 */
export function sendSmsCode(params) {
    return get('/mpp/auth/phone/sendMessage', params);
}

/**
 * 用户退出登录
 * userId
 */
export function logout(params) {
    return get('/mpp/user/logout', params);
}

/**
 * 用户信息
 */
export function getUserInfo(params) {
    return get('/mpp/user/getUserCache', params);
}

/**
 * 用户列表
 * pageNum
 * pageSize
 */
export function getUserList(params) {
	//return get('/mpp/user/findListFull', params);//太卡
	return get('/mpp/user/findList', params);
}

/**
 * 用户详情
 * id
 */
export function getUserById(params) {
    return get('/mpp/user/getFull', params);
}
/**
 * 用户详情
 * id
 */
export function getUserDetail(params) {
    return get('/tianyilife/user/getUserDetail', params);
}

/**
 * 新增用户
 * userName: '', //用户名
 * deptId: '', //部门
 * workNumber: '', //工号
 * postIds: '', //岗位
 * mppDept: {},
 * company: {},
 * roleIds: [],
 * status: 1
 * userPass: '', //密码
 * confirmPass: '',
 * userRealname: '', //真实姓名
 * userMobile: '', //手机号码
 * userTelephone: '', //用户电话
 * userEmail: '', //邮箱
 * companyId: '', //公司
 */
export function addUser(params) {
    return post('/mpp/user/add', params);
}
/**
 * 新增用户
 * userName: '', //用户名
 * deptId: '', //部门
 * workNumber: '', //工号
 * postIds: '', //岗位
 * mppDept: {},
 * company: {},
 * roleIds: [],
 * status: 1
 * userPass: '', //密码
 * confirmPass: '',
 * userRealname: '', //真实姓名
 * userMobile: '', //手机号码
 * userTelephone: '', //用户电话
 * userEmail: '', //邮箱
 * companyId: '', //公司
 */
export function addUserInsert(params) {
    return post('/tianyilife/user/insert', params);
}

/**
 * 编辑用户
 *  userName: '', //用户名
 * deptId: '', //部门
 * workNumber: '', //工号
 * postIds: '', //岗位
 * mppDept: {},
 * company: {},
 * roleIds: [],
 * status: 1
 * userPass: '', //密码
 * confirmPass: '',
 * userRealname: '', //真实姓名
 * userMobile: '', //手机号码
 * userTelephone: '', //用户电话
 * userEmail: '', //邮箱
 * companyId: '', //公司
 */
export function editUser(params) {
    return post('/mpp/user/edit', params);
}
/**
 * 编辑用户
 *  userName: '', //用户名
 * deptId: '', //部门
 * workNumber: '', //工号
 * postIds: '', //岗位
 * mppDept: {},
 * company: {},
 * roleIds: [],
 * status: 1
 * userPass: '', //密码
 * confirmPass: '',
 * userRealname: '', //真实姓名
 * userMobile: '', //手机号码
 * userTelephone: '', //用户电话
 * userEmail: '', //邮箱
 * companyId: '', //公司
 */
export function updateById(params) {
    return post('/tianyilife/user/updateById', params);
}

/**
 * 删除用户
 * ids: 用户id,支持批量删除
 */
export function deleteUser(params) {
    return deleteFun('/mpp/user/delete', params);
}

/**
 * 上传用户头像
 * file
 */
export function uploadAvatar(params) {
    return upload('/mpp/image/upload', params);
}
